import { render, staticRenderFns } from "./cases_page.vue?vue&type=template&id=72874a35"
import script from "./cases_page.vue?vue&type=script&lang=js"
export * from "./cases_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports